import React from 'react';
import { Stack, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import LinearProgress from '@mui/material/LinearProgress';

// ************************************************************

export default function EcuFwResellerDeleteDialog(props) {
  
  const handleClose = () => {
    props.onClickClose()
  }
  const handleSubmit = () => {
    props.onClickSubmit(props.deleteRow)
  }

  var view_en = {
    cancel_button: true,
    delete_button: true,
    show_spin: false,
  }  
  if (props.spin) {
    view_en.cancel_button = false
    view_en.delete_button = false
    view_en.show_spin = true
  }
    
  const row = props.deleteRow || {}

  return (    
    <div>      
      <Dialog 
        maxWidth='sm'
        fullWidth={true}
        open={props.open} 
      >
        <DialogTitle>DELETE FW RESELLER</DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <DialogContentText>
              Are you sure you want to delete this entry?
            </DialogContentText>
            <DialogContentText>
              <strong>ECU Prefix:</strong> {row.ecu_prefix}<br/>
              <strong>Country:</strong> {row.country_code || '(any)'}<br/>
              <strong>Reseller:</strong> {row.reseller_username || (row.reseller_id === -1 ? '(any)' : row.reseller_id)}<br/>
              <strong>FW Name:</strong> {row.fw_name}
            </DialogContentText>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button disabled={!view_en.cancel_button} onClick={handleClose}>Cancel</Button>
          <Button disabled={!view_en.delete_button} onClick={handleSubmit} color="error">Delete</Button>
        </DialogActions>
        {view_en.show_spin && <LinearProgress />}
      </Dialog>
    </div>
  );
}
